<div class="dropdown feature-dropdown">

    <button aria-expanded="true" aria-haspopup="true"
            aria-label="Feature-Menü anzeigen" class="btn dropdown-toggle dropup visibility-toggle-button-button" data-bs-toggle="dropdown" id="visibility-toggle-button"
            type="button">
        <span><i aria-hidden="true" class="fa fa-eye fa-14"></i> <i aria-hidden="true"
                                                                    class="fa fa-caret-down"></i></span>
    </button>

    <ul aria-labelledby="visibility-toggle-button" class="dropdown-menu dropdown-menu-end">
        <li (click)="toggleNotes($event, true)">
            <button class="dropdown-item">
                <i (click)="toggleNotes($event)"
                   [class.fa-eye-slash]="!bookFeatureActivationService.rectsVisible"
                   [class.fa-eye]="bookFeatureActivationService.rectsVisible"
                   aria-hidden="true"
                   class="fa fa-13 float-end">
                </i>
                <i class="fa fa-sticky-note fa-13 margin-right-8"></i>
                Notizen & Markierungen
            </button>
        </li>

        <li (click)="toggleDrawings($event, true)">
            <button class="dropdown-item">
                <i (click)="toggleDrawings($event)"
                   [class.fa-eye-slash]="!bookFeatureActivationService.pageDrawingsVisible"
                   [class.fa-eye]="bookFeatureActivationService.pageDrawingsVisible"
                   aria-hidden="true"
                   class="fa fa-13 float-end">
                </i>
                <i class="fa fa-paint-brush fa-13 margin-right-8"></i>
                Text & Zeichnungen
            </button>
        </li>

        <!-- <li *ngIf="!applicationStateService.isOfflineModeEnabled && applicationStateService.bookConfig.readSpeakerEnabled"
        (click)="toggleReadspeaker($event, true)">
        <span>
          <i class="fa fa-13 float-end"
            [class.fa-eye]="bookFeatureActivationService.readspeakerElementsVisible"
            [class.fa-eye-slash]="!bookFeatureActivationService.readspeakerElementsVisible"
            (click)="toggleReadspeaker($event)"
            aria-hidden="true">
          </i>
          <i class="fa fa-volume-up fa-13 margin-right-8"></i>
          Hörbuch
        </span>
      </li> -->

        @if (!applicationStateService.isOfflineModeEnabled) {
            <li
                    (click)="toggleVideosAudiosAndInteractiveTasks($event, true)">
                <button class="dropdown-item">
                    <i (click)="toggleVideosAudiosAndInteractiveTasks($event)"
                       [class.fa-eye-slash]="!bookFeatureActivationService.videosVisible"
                       [class.fa-eye]="bookFeatureActivationService.videosVisible"
                       aria-hidden="true"
                       class="fa fa-13 float-end">
                    </i>
                    <i class="fas fa-video fa-13 margin-right-8"></i>
                    Videos & Audios und Links
                </button>
            </li>
        }
    </ul>
</div>

